import { STUDENT_DASHBOARD_PATH } from "../config/studentNavItems"

/** Match learner-dashboard-design active-nav rules for student routes. */
export const isStudentNavActive = (pathname: string, path: string): boolean => {
  if (path === STUDENT_DASHBOARD_PATH) {
    return pathname === STUDENT_DASHBOARD_PATH
  }
  return pathname.startsWith(path)
}
